const STORAGE_KEY = "lovable:app-mode";
const WINDOW_KEY = "__alkoholprovetAppMode";

// Latches app-mode for the tab: URL ?app=1 is the source of truth, with a
// sessionStorage fallback so SPA navigations/reloads stay in app-mode.
export function isAppMode(): boolean {
  if (typeof window === "undefined") return false;

  const w = window as unknown as Record<string, unknown>;
  if (w[WINDOW_KEY] === true) return true;

  let active = false;
  try {
    active = new URLSearchParams(window.location.search).get("app") === "1";
  } catch { /* ignore */ }

  if (!active) {
    try {
      active = window.sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch { /* ignore */ }
  }

  if (active) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, "1");
    } catch { /* ignore */ }
    w[WINDOW_KEY] = true;
  }

  return active;
}
